import DeleteCustomFieldModal from './DeleteCustomFieldModal';

export default DeleteCustomFieldModal;
